/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
import React from "react";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  OptionList: function (data, addon) {
    const id = addon?.id ?? "";
    const keyName = addon?.key ?? "";
    const columnName = addon?.name ? addon.name : "name";
    const columnValue = addon?.value ? addon.value : "value";
    const title = addon?.title ? addon.title : "";
    const optionGroup = addon?.optionGroup ? addon.optionGroup : false;
    const optionNull = addon?.optionNull ? addon.optionNull : false;
    let options = [];
    // return options;
    if (title !== "") {
      options.push({
        value: "",
        text: title,
        name: keyName,
        key: "option-" + keyName,
        id: id,
      });
    }
    if (optionGroup) {
      let tmp = {};
      let inx = -1;
      for (let group in data) {
        let groupData = data[group];
        for (const i in groupData) {
          let row = groupData[i];
          const isObj = row !== null && typeof row === "object";
          const value = isObj ? row[columnValue] ?? row[columnName] : row;
          const text = isObj
            ? row[columnName] ?? row[columnValue] ?? String(row)
            : String(row);
          if (tmp?.[value]) continue;
          tmp[value] = 1;
          inx += 1;
          options.push({
            value: value,
            text,
            name: keyName,
            key: "option-" + keyName + "-" + inx,
            id: id,
          });
        }
      }
    } else {
      for (const i in data) {
        let row = data[i];
        const isObj = row !== null && typeof row === "object";
        const value = isObj ? row[columnValue] ?? row[columnName] : row;
        const text = isObj
          ? row[columnName] ?? row[columnValue] ?? String(row)
          : String(row);

        options.push({
          value: value,
          text,
          name: keyName,
          key: "option-" + keyName + "-" + i,
          id: id,
        });
      }
    }
    return options;
  },
  Options: function ({ data, addon }) {
    const keyName = addon.key;
    const columnName = addon?.name ? addon.name : "name";
    const columnValue = addon?.value ? addon.value : "value";
    const title = addon?.title ? addon.title : "";
    const optionGroup = addon?.optionGroup ? addon.optionGroup : false;
    const optionNull = addon?.optionNull ? addon.optionNull : false;

    let options = [];
    if (title !== "") {
      options.push(
        <option
          key={"option-" + keyName}
          disabled={!optionNull ? true : false}
          value=""
        >
          {title}
        </option>
      );
    }
    if (optionGroup) {
      for (let group in data) {
        let groupData = data[group];
        let tmp = [];
        for (const i in groupData) {
          let row = groupData[i];
          let value = columnValue in row ? row[columnValue] : row[columnName];
          if ("isHead" in row && row.isHead) {
            tmp.push(
              <option
                key={"option-" + keyName + "-" + i}
                disabled
                value={value}
              >
                {row[columnName]}
              </option>
            );
            continue;
          }
          tmp.push(
            <option key={"option-" + keyName + "-" + i} value={value}>
              {row[columnName]}
            </option>
          );
        }
        options.push(
          <optgroup key={"option-group-" + keyName + "-" + group} label={group}>
            {tmp}
          </optgroup>
        );
      }
    } else {
      for (const i in data) {
        let row = data[i];
        let value = columnValue in row ? row[columnValue] : row[columnName];
        if ("isHead" in row && row.isHead) {
          options.push(
            <option key={"option-" + keyName + "-" + i} disabled value={value}>
              {row[columnName]}
            </option>
          );
          continue;
        }
        options.push(
          <option key={"option-" + keyName + "-" + i} value={value}>
            {row[columnName]}
          </option>
        );
        //if(keyName=="leavestatus") console.log(row[columnName]);
      }
    }
    return options;
  },
  SelectAll: function ({ handleEvents }) {
    return (
      <div className="btn-select-all">
        <div className="select-all" onClick={handleEvents.SelectAll.OnClick}>
          Select ALL
        </div>
        <div style={{ float: "left", margin: "0 5px", fontSize: "11px" }}>
          |
        </div>
        <div className="select-none" onClick={handleEvents.SelectNone.OnClick}>
          NONE
        </div>
      </div>
    );
  },
  NoAccess: function () {
    return (
      <div key="noaccess-content">
        <h5 style={{ textAlign: "center" }}>Cannot access this report!</h5>
      </div>
    );
  },
  Paginations: function ({ totalPage, activePage, className, handleEvents }) {
    if (totalPage <= 1) {
      return "";
    }
    /*return (<Pagination
            activePage={activePage}
            items={totalPage}
            leftBtn={<Icon>chevron_left</Icon>}
            rightBtn={<Icon>chevron_right</Icon>}
            className={className}
            onSelect={handleEvents}
            />
        );*/
    var beforePage = activePage - 1;
    var afterPage = activePage + 1;
    var li = [];
    li.push(
      <li
        key="page-index-1"
        className={activePage == 1 ? "active" : "waves-effect"}
      >
        <a className="btn-page" href="#" page-index="1" onClick={handleEvents}>
          1
        </a>
      </li>
    );
    let i = Math.max(2, activePage - 5);
    if (i > 2)
      li.push(
        <li key="page-index-dot-1" style={{ lineHeight: "34px" }}>
          ...
        </li>
      );
    for (; i < Math.min(activePage + 6, totalPage); i++) {
      var liClass = activePage == i ? "active" : "waves-effect";
      li.push(
        <li key={"page-index-" + i} className={liClass}>
          <a
            className="btn-page"
            href="#"
            page-index={i}
            onClick={handleEvents}
          >
            {i}
          </a>
        </li>
      );
    }
    if (i != totalPage)
      li.push(
        <li key="page-index-dot-2" style={{ lineHeight: "34px" }}>
          ...
        </li>
      );
    li.push(
      <li
        key={"page-index-" + totalPage}
        className={activePage == totalPage ? "active" : "waves-effect"}
      >
        <a
          className="btn-page"
          href="#"
          page-index={totalPage}
          onClick={handleEvents}
        >
          {totalPage}
        </a>
      </li>
    );

    return (
      <ul className="pagination" style={{ textAlign: "center" }}>
        <li
          key="page-index-before"
          className={beforePage <= 0 ? "disabled" : "waves-effect"}
        >
          <a
            className="btn-page"
            href="#"
            page-index={beforePage <= 0 ? 1 : beforePage}
            onClick={handleEvents}
          >
            <i className="material-icons">chevron_left</i>
          </a>
        </li>
        {li}
        <li
          key="page-index-after"
          className={afterPage > totalPage ? "disabled" : "waves-effect"}
        >
          <a
            className={"btn-page a" + afterPage + " p" + totalPage}
            href="#"
            page-index={afterPage > totalPage ? totalPage : afterPage}
            onClick={handleEvents}
          >
            <i className="material-icons">chevron_right</i>
          </a>
        </li>
      </ul>
    );
  },
  Preloading: function ({ addon }) {
    let addClass =
      "class" in addon && addon.class != "" && addon.class != undefined
        ? " " + addon.class
        : "";
    let addCSS =
      "css" in addon && addon.css != "" && addon.css != undefined
        ? addon.css
        : {};
    let loading = (
      <div className={"preloader-wrapper active" + addClass} style={addCSS}>
        <div className="spinner-layer spinner-green-only">
          <div className="circle-clipper left">
            <div className="circle"></div>
          </div>
          <div className="gap-patch">
            <div className="circle"></div>
          </div>
          <div className="circle-clipper right">
            <div className="circle"></div>
          </div>
        </div>
      </div>
    );
    return loading;
  },
};
